import { useEffect, useState } from "react";
import { Banknote, GraduationCap, ScrollText, Gift } from "lucide-react";
import "./quizHomeStyles.css";

function QuizHomePage() {
  return (
    <>
      {/* <nav className="navbar navbar-expand-lg navbar-light bg-white">
        <div className="container-fluid">
          <a className="navbar-brand" href="/quizhomepage">
            <img
              src="../images/docmasterLogo.png"
              alt="DocMaster Quiz Logo"
              className="quiz-landing-logo"
              style={{ width: "180px" }}
            />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarText"
            aria-controls="navbarText"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarText">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a
                  className="nav-link active"
                  aria-current="page"
                  href="/QuizHomePage"
                >
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/quiz-dashboard">
                  Dashboard
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/quiz-syllabus">
                  Syllabus
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/participate">
                  How to Participate
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/testimonials">
                  Testimonials
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/contact">
                  Contact us
                </a>
              </li>
            </ul>
            <button className="btn btn-sm btn-outline-primary mb-0 me-2">
              Sign In
            </button>
            <button className="btn btn-sm btn-primary mb-0">Get Started</button>
          </div>
        </div>
      </nav> */}
      <section className="quiz-landing-section d-flex align-items-center py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-2"></div>
            <div className="col-md-8 text-center  pt-4">
              <h1 className="quiz-landing-heading mb-0 bold  text-white">
                Master Knowledge with
              </h1>
              <h1 className="quiz-landing-heading mb-4 bold text-orange mt-0">
                DocMaster Quiz
              </h1>
              <h4 className="quiz-landing-subheading mb-4 text-white text-18 bold mb-4">
                Join thousands of students in interactive learning. Practice,
                Complete and<br className="d-none d-md-block"></br>win amazing
                prizes!
              </h4>
              <button className="btn btn-sm btn-success mb-0 me-3 text-16 bold text-white ">
                Start Your Journey
              </button>
              <button className="btn btn-sm btn-primary mb-0 text-16 bold text-white">
                How to Participate
              </button>
              {/* <div className="mt-5 row">
                <div className="col-6 col-md-3 text-center mb-3 mb-md-0">
                  <img
                    src="../images/quiz/2.png"
                    alt="Students Icon"
                    className="quiz-landing-stats-icon"
                  />
                  <h2 className="quiz-landing-stats-number text-22 mb-0 bold text-white">
                    10,000+
                  </h2>
                  <p className="bold quiz-landing-stats-label text-15 text-white">
                    Active Students
                  </p>
                </div>
                <div className="col-6 col-md-3 text-center mb-3 mb-md-0">
                  <img
                    src="../images/quiz/3.png"
                    alt="Students Icon"
                    className="quiz-landing-stats-icon"
                  />
                  <h2 className="quiz-landing-stats-number text-22 mb-0 bold text-white">
                    500+
                  </h2>
                  <p className="bold quiz-landing-stats-label text-15 text-white">
                    Schools Registered
                  </p>
                </div>
                <div className="col-6 col-md-3 text-center">
                  <img
                    src="../images/quiz/4.png"
                    alt="Students Icon"
                    className="quiz-landing-stats-icon"
                    style={{ width: "30px" }}
                  />
                  <h2 className="quiz-landing-stats-number text-22 mb-0 bold text-white">
                    50,000+
                  </h2>
                  <p className="bold quiz-landing-stats-label text-15 text-white">
                    Prize Distributed
                  </p>
                </div>
                <div className="col-6 col-md-3 text-center">
                  <img
                    src="../images/quiz/5.png"
                    alt="Students Icon"
                    className="quiz-landing-stats-icon"
                  />
                  <h2 className="quiz-landing-stats-number text-22 mb-0 bold text-white">
                    4.9/5
                  </h2>
                  <p className="bold quiz-landing-stats-label text-15 text-white">
                    Student Rating
                  </p>
                </div>
              </div> */}
            </div>
            {/* <div className="col-md-3"></div> */}
          </div>
        </div>
      </section>
      <section
        className="quiz-landing-partners-section py-4"
        style={{ backgroundColor: "#f6f6f6" }}
      >
        <div className="container text-center py-2">
          <div className="row">
            <h1 className="bold mb-2 text-blue">
              Various Type of Exciting Quizzes
            </h1>
            <p className="text-20 mb-3 text-gray">
              Choose your learning path - practice at your own pace
              <br className="d-none d-md-block"></br> or Complete in live
              challenge!
            </p>
          </div>
          <div className="row align-items-stretch">
            <div className="col-md-6 mb-3 mb-md-0 text-start">
              <div className="card mx-2 rounded-lg h-100">
                <div className="card-body p-0">
                  <div
                    className="d-flex justify-content-between align-items-start"
                    style={{ minHeight: "42px" }}
                  >
                    <div className="px-3 pt-2 pb-0">
                      <img
                        src="../images/quiz/6.png"
                        alt="Practice Quiz Icon"
                        style={{ width: "32px" }}
                      />
                    </div>
                    <div className="px-3 pt-2 pb-0">
                      <span className="px-2 py-1 rounded-lg bg-success text-white text-15 align-self-start">
                        <b>Free</b>
                      </span>
                    </div>
                  </div>

                  <div className="px-3 pb-2 pt-0 text-start">
                    <h4 className="card-title text-20 mb-1">
                      Practice Quizzes
                    </h4>
                    <p className="card-text text-18 mb-2">
                      Subject-based learning at your own pace
                    </p>

                    {/* Make style same as Live quiz */}
                    <div className="row">
                      <div className="col-6 col-md-6 text-center">
                        <div
                          className="rounded-lg mx-2 px-3 py-2 mb-2"
                          style={{ background: "#ebecec" }}
                        >
                          <img
                            src="../images/quiz/7.png"
                            alt="Practice Quiz Icon"
                            style={{ width: "18px" }}
                          />
                          <p className="text-18 mb-0">
                            <b>Academic Quiz</b>
                          </p>
                          <p className="text-15 mb-0">Subject - Specific</p>
                        </div>
                      </div>

                      <div className="col-6 col-md-6 text-center">
                        <div
                          className="rounded-lg mx-2 px-3 py-2 mb-2"
                          style={{ background: "#ebecec" }}
                        >
                          <img
                            src="../images/quiz/8.png"
                            alt="Practice Quiz Icon"
                            style={{ width: "18px" }}
                          />
                          <p className="text-18 mb-0">
                            <b>Thematic Quiz</b>
                          </p>
                          <p className="text-15 mb-0">Subject - Specific</p>
                        </div>
                      </div>
                    </div>

                    <a
                      href="#"
                      className="btn btn-success btn-sm text-20 w-100"
                    >
                      Start Practicing
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card mx-2 rounded-lg h-100">
                <div className="card-body p-0">
                  <div
                    className="d-flex justify-content-between align-items-start"
                    style={{ minHeight: "42px" }}
                  >
                    <div className="px-3 pt-2 pb-0"></div>
                    <div className="px-3 pt-2 pb-0">
                      <span className=" px-2 py-1 rounded-lg bg-orange text-white text-15 align-self-start">
                        <b>Live</b>
                      </span>
                    </div>
                  </div>
                  <div className="px-3 pb-2 pt-0 text-start">
                    <h4 className="card-title text-20 mb-1">Live Quizzes</h4>
                    <p className="card-text text-18 mb-2">
                      Real-time competitive challenges with prizes
                    </p>
                    <div className="row">
                      <div className="col-6 col-md-6 text-center">
                        <div
                          className="rounded-lg  mx-2 px-3 py-2 mb-2"
                          style={{ background: "#ebecec" }}
                        >
                          <img
                            src="../images/quiz/7.png"
                            alt="Practice Quiz Icon"
                            style={{ width: "18px" }}
                          />
                          <p className="text-18 mb-0">
                            <b>Academic Quiz</b>
                          </p>
                          <p className="text-15 mb-0">Subject - Specific</p>
                        </div>
                      </div>
                      <div className="col-6 col-md-6 text-center">
                        <div
                          className="rounded-lg mx-2 px-3 py-2 mb-2"
                          style={{ background: "#ebecec" }}
                        >
                          <img
                            src="../images/quiz/8.png"
                            alt="Practice Quiz Icon"
                            style={{ width: "18px" }}
                          />
                          <p className="text-18 mb-0">
                            <b>Thematic Quiz</b>
                          </p>
                          <p className="text-15 mb-0">Subject - Specific</p>
                        </div>
                      </div>
                    </div>

                    <a
                      href="#"
                      className="btn btn-primary bg-blue text-20 w-100"
                    >
                      Join Live Quiz
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="quiz-landing-partners-section py-4"
        style={{ backgroundColor: "#fff" }}
      >
        <div className="container text-center py-2">
          <div className="row">
            <h1 className="bold mb-2 text-blue">Amazing Prizes & Rewards</h1>
            <p className="text-20 mb-3 text-gray">
              Practice quizzes and win exciting prizes, scholarships, and
              certificates
            </p>
          </div>
          <div className="row">
            <div className="col-6 col-md-3 mb-3">
              <div className="card rounded-lg mx-2 py-4 px-3 text-center h-100">
                <div
                  className="mb-2 p-3 mx-auto"
                  style={{
                    background: "#fef2e9",
                    borderRadius: "50%",
                    width: "70px",
                    height: "70px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Banknote size={34} color="#ef7f1a" strokeWidth={1.8} />
                </div>
                <h5 className="bold mt-1 text-20 mb-1">Cash Prize</h5>
                <h4 className="text-orange bold text-22">₹50,000+</h4>
                <p className="text-15 text-gray mb-2">
                  Total prize pool distribution monthly
                </p>
                {/* <p className="text-16 text-gray mb-0">
                  Regular Quiz: ₹500 - ₹2,000
                </p>
                <p className="text-16 text-gray mb-0">
                  Live Quiz: ₹5,000 - ₹25,000
                </p> */}
              </div>
            </div>
            <div className="col-6 col-md-3 mb-3">
              <div className="card rounded-lg mx-2 py-4 px-3 text-center h-100">
                <div
                  className="mb-2 p-3 mx-auto"
                  style={{
                    background: "#e9f3eb",
                    borderRadius: "50%",
                    width: "70px",
                    height: "70px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <GraduationCap size={34} color="#ef7f1a" strokeWidth={1.8} />
                </div>
                <h5 className="bold mt-1 text-20 mb-1">Scholarships</h5>
                <h4 className="text-orange bold text-22">₹1,00,000</h4>
                <p className="text-15 text-gray mb-2">
                  Annual scholarships program
                </p>
                {/* <p className="text-16 text-gray mb-0">Merit based selection</p>
                <p className="text-16 text-gray mb-0">
                  Academic excellence rewards
                </p> */}
              </div>
            </div>
            <div className="col-6 col-md-3 mb-3">
              <div className="card rounded-lg mx-2 py-4 px-3 text-center h-100">
                <div
                  className="mb-2 p-3 mx-auto"
                  style={{
                    background: "#e6e9f6",
                    borderRadius: "50%",
                    width: "70px",
                    height: "70px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <ScrollText size={34} color="#ef7f1a" strokeWidth={1.8} />
                </div>
                <h5 className="bold mt-1 text-20 mb-1">Certificates</h5>
                <h4 className="text-orange bold text-22">Digital</h4>
                <p className="text-15 text-gray mb-2">
                  Downloadable certificates
                </p>
                {/* <p className="text-16 text-gray mb-0">
                  Participation certificates
                </p>
                <p className="text-16 text-gray mb-0">Achievement awards</p> */}
              </div>
            </div>

            <div className="col-6 col-md-3 mb-3">
              <div className="card rounded-lg mx-2 py-4 px-3 text-center h-100">
                <div
                  className="mb-2 p-3 mx-auto"
                  style={{
                    background: "#fef6e6",
                    borderRadius: "50%",
                    width: "70px",
                    height: "70px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Gift size={34} color="#ef7f1a" strokeWidth={1.8} />
                </div>
                <h5 className="bold mt-1 text-20 mb-1">Special Rewards</h5>
                <h4 className="text-orange bold text-22">Gadgets</h4>
                <p className="text-15 text-gray mb-2">
                  Tablets, Books and more
                </p>
                {/* <p className="text-16 text-gray mb-0">Educational Gadgets</p>
                <p className="text-16 text-gray mb-0">Books and resources</p> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="quiz-landing-partners-section py-5 mb-5"
        style={{ backgroundColor: "#f6f6f6" }}
      >
        <div className="container-fluid text-center py-4">
          <div className="row">
            <h1 className="bold mb-4 text-blue">Quiz Competition Level</h1>
          </div>
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-6 col-md-2 w-md-20 mb-3 mb-md-0">
              <div className="card rounded-lg p-3 text-center mx-2">
                <h4 className="bold mb-0 text-blue">School Level</h4>
                <p className="mb-0">Fee: Free</p>
                <p className="text-orange bold mb-0">₹1,000</p>
              </div>
            </div>
            <div className="col-6 col-md-2 w-md-20 mb-3 mb-md-0">
              <div className="card rounded-lg p-3 text-center mx-2">
                <h4 className="bold mb-0 text-blue">Inter Level</h4>
                <p className="mb-0">Fee: ₹25</p>
                <p className="text-orange bold mb-0">₹5,000</p>
              </div>
            </div>
            <div className="col-6 col-md-2 w-md-20 mb-3 mb-md-0">
              <div className="card rounded-lg p-3 text-center mx-2">
                <h4 className="bold mb-0 text-blue">District Level</h4>
                <p className="mb-0">Fee: ₹35</p>
                <p className="text-orange bold mb-0">₹15,000</p>
              </div>
            </div>
            <div className="col-6 col-md-2 w-md-20 mb-3 mb-md-0">
              <div className="card rounded-lg p-3 text-center mx-2">
                <h4 className="bold mb-0 text-blue">State Level</h4>
                <p className="mb-0">Fee: ₹50</p>
                <p className="text-orange bold mb-0">₹35,000</p>
              </div>
            </div>
            <div className="col-12 col-md-2 w-md-20">
              <div className="card rounded-lg p-3 text-center mx-2">
                <h4 className="bold mb-0 text-blue">National Level</h4>
                <p className="mb-0">Fee: ₹75</p>
                <p className="text-orange bold mb-0">₹50,000</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <footer
        className="quiz-landing-footer bg-blue text-white py-4"
        style={{ backgroundColor: "#062b7a" }}
      >
        <div className="container-fluid text-start">
          <div className="row">
            <div className="col-md-3">
              <a
                className="navbar-brand"
                href="/quizhomepage"
                style={{
                  backgroundColor: "#fff",
                  padding: "15px",
                  borderRadius: "8px",
                }}
              >
                <img
                  src="../images/docmasterLogo.png"
                  alt="DocMaster Quiz Logo"
                  className="quiz-landing-logo"
                  style={{ width: "180px" }}
                />
              </a>
              <div className="d-flex justify-content-center mt-3 mb-3">
                <p className="text-15 mb-0">
                  Empowering students through interactive learning and
                  competitive quizzes.Building the future of education, one
                  question at a time.
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <h5 className="bold mb-3 text-white">Quick Links</h5>
              <ul className="mb-3">
                <li>
                  <a href="#" className="text-white mx-3">
                    Dashboard
                  </a>
                </li>
                <li>
                  <a href="#" className="text-white mx-3">
                    Syllabus
                  </a>
                </li>
                <li>
                  <a href="#" className="text-white mx-3">
                    How to Participate
                  </a>
                </li>
                <li>
                  <a href="#" className="text-white mx-3">
                    Profile
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-3">
              <h5 className="bold mb-3 text-white">Support</h5>
              <ul className="  mb-3">
                <li>
                  <a href="#" className="text-white mx-3">
                    FAQ's
                  </a>
                </li>
                <li>
                  <a href="#" className="text-white mx-3">
                    Terms & Conditions
                  </a>
                </li>
                <li>
                  <a href="#" className="text-white mx-3">
                    Contact Us
                  </a>
                </li>
                <li>
                  <a href="#" className="text-white mx-3">
                    Testimonials
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-3">
              <h5 className="bold mb-3 text-white">Contact info</h5>
              <ul className=" list-unstyled mb-3">
                <li>
                  <a href="#" className="text-white mx-3">
                    info@docmasterquiz.com
                  </a>
                </li>
                <li>
                  <a href="#" className="text-white mx-3">
                    +91 98765 43210
                  </a>
                </li>
                <li>
                  <a href="#" className="text-white mx-3">
                    Mumbai, Maharastra, India
                  </a>
                </li>
              </ul>
              <div className="d-flex  justify-content-center mb-3">
                <a href="#" className="text-white mx-3">
                  <i className="fab fa-facebook "></i>
                </a>
                <a href="#" className="text-white mx-3">
                  <i className="fab fa-twitter "></i>
                </a>
                <a href="#" className="text-white mx-3">
                  <i className="fab fa-instagram "></i>
                </a>
                <a href="#" className="text-white mx-3">
                  <i className="fab fa-linkedin "></i>
                </a>
              </div>
            </div>
          </div>
          <hr className="mb-4" style={{ borderColor: "#fff" }} />
          <p className="mb-0 text-center">
            © 2024 DocMaster Quiz. All rights reserved.
          </p>
        </div>
      </footer> */}
    </>
  );
}

export default QuizHomePage;
